export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || 'https://dev.admin.nobrinde.immera.io'

export const VENDURE_AUTH_TOKEN_HEADER_KEY = 'vendure-auth-token'
export const VENDURE_CHANNEL_TOKEN_HEADER_KEY = 'vendure-channel-token'
export const VENDURE_LANGUAGE_CODE_HEADER_KEY = 'vendure-language-code'

/**
 * Product listings (search, category, autocomplete, related products, kit picker) query the
 * Meilisearch-backed `meiliSearch` instead of Vendure's `search`. Build-time switch, so it is also
 * the rollback: rebuild with `vendure` (the default) to go back.
 */
export const USE_MEILI_SEARCH = import.meta.env.VITE_SEARCH_ENGINE === 'meili'
